import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'loadingDetail': false,
  'list': [],
};

const addUpdatedArea = (list, newRecord) => {
  const oldRecordIndex = list.findIndex((item) => item.primaryCode === newRecord.primaryCode);
  return [
    ...list.slice(0, oldRecordIndex),
    newRecord,
    ...list.slice(oldRecordIndex + 1),
  ];
};

export const logisticServices = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_LOGISTIC_AREAS]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [ActionTypes.FETCHING_LOGISTIC_AREAS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_LOGISTIC_AREAS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data.map((x) => {
        return {...x, 'uniqueId': `${x.primaryCode}${x.secondaryCode}`};
      }),
    }),
    [ActionTypes.FETCHED_LOGISTIC_AREAS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.ADDING_LOGISTIC_AREAS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_LOGISTIC_AREAS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [action.response.data, ...state.list],
    }),
    [ActionTypes.ADDED_LOGISTIC_AREAS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_LOGISTIC_AREAS]: (state, action) => ({
      ...state,
      'loadingDetail': true,
    }),
    [ActionTypes.UPDATED_LOGISTIC_AREAS]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'list': addUpdatedArea(state.list, action.response.data),
    }),
    [ActionTypes.UPDATED_LOGISTIC_AREAS_FAILED]: (state, action) => ({
      ...state,
      'loadingDetail': false,
    }),
  })(state, action);
};
